import React from "react";
import "./Taisao.css";

const cards = [
  {
    id: 1,
    tone: "green",
    icon: "🛡",
    eyebrow: "An toàn",
    title: "Cam Kết An Toàn Trong Mọi Giao Dịch",
    desc: "Bạn tự cầm thẻ, tự nhập OTP. Nhân viên chỉ cầm máy POS — không ai chạm vào thẻ của bạn.",
  },
  {
    id: 2,
    tone: "purple",
    icon: "🔒",
    eyebrow: "Bảo mật",
    title: "Bảo Mật Thông Tin Khách Hàng Hàng Đầu",
    desc: "Không lưu số thẻ, không chụp ảnh, không chia sẻ thông tin. Giao dịch xong — dữ liệu biến mất.",
  },
  {
    id: 3,
    tone: "orange",
    icon: "$",
    eyebrow: "Phí rẻ — minh bạch",
    title: "Chỉ 1% ",
    desc: "Phí báo trước là phí thanh toán. Không phí xăng xe, không phí máy",
  },
  {
    id: 4,
    tone: "amber",
    icon: "◔",
    eyebrow: "Nhanh",
    title: "Trung bình 15 phút",
    desc: "Nhân viên trực 24/7, không cần hẹn trước. Gọi — xác nhận — có tiền. Đúng vậy, nhanh vậy.",
  },
];

export default function Taisao() {
  return (
    <section className="why-shopee">
      <div className="why-shopee__container">
        <div className="why-shopee__header">
          <p style={{ textAlign: "center" }} className="why-shopee__eyebrow">
            Tại sao chọn chúng tôi
          </p>
          <h2 style={{ textAlign: "center" }} className="why-shopee__title">
            Đừng chọn bừa — đây là sự khác biệt bạn cần biết
          </h2>
        </div>

        <div className="why-shopee__grid">
          {cards.map((card) => (
            <article
              key={card.id}
              className={`why-card why-card--${card.tone}`}
            >
              <div className="why-card__top">
                <span className={`why-card__icon why-card__icon--${card.tone}`}>
                  {card.icon}
                </span>

                <div className="why-card__meta">
                  <span className="why-card__eyebrow">{card.eyebrow}</span>
                </div>
              </div>

              <h3 className="why-card__title">{card.title}</h3>
            </article>
          ))}
        </div>
        <div className="process-cta">
          <div className="process-cta__actions">
            <a
              onClick={() => {
                window.dataLayer = window.dataLayer || [];

                window.dataLayer.push({
                  event: "goi",
                });
              }}
              href="tel:0941395019"
              className="cta-btn cta-btn--call"
            >
              📞 Gọi ngay 0941 395 019
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
